import { render } from "./FailedJobReasonModal.vue?vue&type=template&id=e4906f98&ts=true"
import script from "./FailedJobReasonModal.vue?vue&type=script&lang=ts"
export * from "./FailedJobReasonModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__